var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-title",style:({ backgroundImage: ("url(" + _vm.titleBg + ")") })},[_c('h3',{staticClass:"ch-title"},[_vm._v(_vm._s(_vm.titleCh))]),_vm._v(" "),_c('h5',{staticClass:"en-title"},[_vm._v(_vm._s(_vm.titleEn))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b572e16a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FineartSubtitle.vue
// module id = null
// module chunks = 